import { path } from 'ramda'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const useDefaultGreeting = () => {
  const { t } = useTranslation()

  const onlineGreeting = useSelector(state => {
    const welcomeMessage = path(['embed', 'configuration', 'theme', 'welcomeMessage'], state)
    if (welcomeMessage) {
      return welcomeMessage
    }
    return t('greeting.onlineMessage')
  })

  const matchedHours = useSelector(state => state.view.matchedHours)

  const offlineGreeting = useSelector(state => {
    const awayMessage = path(['embed', 'configuration', 'theme', 'awayMessage'], state)

    if (awayMessage) {
      return awayMessage
    }

    return t('greeting.awayMessage')
  })

  return matchedHours ? onlineGreeting : offlineGreeting
}

export default useDefaultGreeting